import Close from '@/app/_components/ui/icons/Close.svg';
import Modal from 'react-modal';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import data from '@/app/_libs/utils/constants/listOfCities';
import Input from '@/app/_components/share/formInputs/Input';
import FormSwitch from '@/app/_components/share/formInputs/FormSwitch';
import Select from '@/app/_components/share/formInputs/Select';
import HiddenInput from '@/app/_components/share/formInputs/HiddenInput';
import { useUpdateAddress, useAddAddress } from '@/app/_hooks/useAddress';
import { usePathname, useRouter } from 'next/navigation';
export default function AddressForm({
  address,
  isAddressModalOpen,
  userToken,
  onCloseModal,
  actionAfterAddOrEdit,
  user,
}) {
  const { push } = useRouter();
  const pathname = usePathname();
  const isAddMode = !address;
  const [isSelf, setIsSelf] = useState(address?.is_self || false);
  const [provinceCities, setProvinceCities] = useState([]);
  const updateAddress = useUpdateAddress(userToken);
  const addAddress = useAddAddress(userToken);

  const formSchema = Yup.object().shape({
    postalAddress: Yup.string().required('فیلد نشانی پستی ضروری است'),
    province: Yup.string().required('فیلد استان ضروری است'),
    // postalCode: Yup.string()
    //   .required('فیلد کدپستی ضروری است')
    //   .matches(/^[0-9]{10}$/, {
    //     excludeEmptyString: true,
    //     message: 'کد پستی نادرست می باشد',
    //   }),
    name: Yup.string().when('isSelf', {
      is: false,
      then: () => Yup.string().required('فیلد نام ضروری است'),
    }),
    family: Yup.string().when('isSelf', {
      is: false,
      then: () => Yup.string().required('فیلد نام خانوادگی ضروری است'),
    }),
    mobile: Yup.string().when('isSelf', {
      is: false,
      then: () => Yup.string().required('فیلد شماره موبایل ضروری است'),
    }),
    province: Yup.string().required('فیلد استان ضروری است'),
    city: Yup.string().required('فیلد شهر ضروری است'),
  });

  function onSubmit(values) {
    return isAddMode ? addAddressHandler(values) : editAddressHandler(values);
  }

  /**
   * ------------------------------------------------------------------------------------------------
   * edit Address Handler
   * ------------------------------------------------------------------------------------------------
   */
  const editAddressHandler = async (values) => {
    updateAddress.mutate(
      { userToken, ...values },
      {
        onSuccess: async () => {
          push(pathname);
          reset(), onCloseModal();
          if (actionAfterAddOrEdit) {
            actionAfterAddOrEdit();
          }
        },
      }
    );
  };
  /**
   * ------------------------------------------------------------------------------------------------
   * addAddressHandler
   * ------------------------------------------------------------------------------------------------
   */
  const addAddressHandler = async (values) => {
    addAddress.mutate(
      { userToken, ...values },
      {
        onSuccess: async () => {
          push(pathname);
          reset(), onCloseModal();
          if (actionAfterAddOrEdit) {
            actionAfterAddOrEdit();
          }
        },
      }
    );
  };

  /**
   * ------------------------------------------------------------------------------------------------
   * register form
   * ------------------------------------------------------------------------------------------------
   */
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });
  /**
   * ------------------------------------------------------------------------------------------------
   * register form
   * ------------------------------------------------------------------------------------------------
   */
  useEffect(() => {
    register('isSelf');
    reset({
      postalAddress: address?.address,
      city: address?.city?.object_id || '',
      province: address?.province?.object_id,
    });
    setProvinceCities([]);
  }, [address, reset, register]);

  /**
   * ------------------------------------------------------------------------------------------------
   * Change city and province handler
   * ------------------------------------------------------------------------------------------------
   */
  const changeCityHandler = (value) => {
    setProvinceCities(data.cities.filter((a) => a.province_id == value));
    reset({
      city: '',
    });
  };

  useEffect(() => {
    if (!isAddMode) {
      setProvinceCities(
        data.cities.filter((a) => a.province_id == address?.province?.id)
      );
      if (address.is_self) {
        setIsSelf(true);
      }
    }
  }, [address]);

  return (
    <div>
      <Modal
        isOpen={isAddressModalOpen == 2 && true}
        onRequestClose={onCloseModal}
        ariaHideApp={false}
        className="AddressModal"
        overlayClassName="modalOverlay"
      >
        <>
          <div className=" modal-header p-5 pb-1 flex justify-between">
            <h2>تغییر آدرس</h2>
            <button onClick={onCloseModal}>
              <Close />
            </button>
          </div>
          <div className="pt-2 pb-4">
            <div className="w-full border-t border-light-gray-200"></div>
          </div>
          <form
            className="w-full max-w-lg h-full"
            id="editAddress"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="h-full overflow-y-auto p-5 pb-40">
              <HiddenInput
                register={register}
                name="id"
                defaultValue={address?.id}
              />
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-full px-3 mb-6 md:mb-0">
                  <div className="flex justify-between">
                    <label
                      className="block uppercase tracking-wide mb-2 text-gray-900 text-sm"
                      htmlFor="postalAddress"
                    >
                      نشانی پستی
                      <span className="text-red-500">*</span>
                    </label>
                    {/* <button
                      className="text-ocean-blue text-gray-900 text-sm"
                      onClick={backToMap}
                    >
                      تغییر موقعیت مکانی روی نقشه
                    </button> */}
                  </div>
                  <textarea
                    className="appearance-none block w-full  text-gray-900 text-sm border border-light-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    {...register('postalAddress')}
                    defaultValue={address?.address}
                    type="text"
                  ></textarea>
                  <span className=" inputValidation text-xs text-red-800">
                    {errors.postalAddress?.message}
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Select
                    register={register}
                    errors={errors}
                    name="province"
                    items={data.provinces}
                    label="استان"
                    required
                    onChangeHandler={changeCityHandler}
                    value={address?.province?.object_id}
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <Select
                    register={register}
                    errors={errors}
                    name="city"
                    items={provinceCities}
                    label="شهر"
                    required
                    value={address?.city?.object_id}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <Input
                    register={register}
                    errors={errors}
                    name="postalCode"
                    defaultValue={address?.postal_code}
                    label="کدپستی "
                  />
                </div>
                <div className="w-full md:w-1/3 px-3">
                  <Input
                    register={register}
                    errors={errors}
                    name="unit"
                    defaultValue={address?.unit}
                    label="واحد "
                    required
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <Input
                    register={register}
                    errors={errors}
                    name="number"
                    defaultValue={address?.number}
                    label="پلاک"
                    required
                  />
                </div>
              </div>

              <div className="flex-wrap flex pb-4 items-center">
                <FormSwitch
                  register={register}
                  errors={errors}
                  name="isSelf"
                  checked={isSelf}
                  label="گیرنده سفارش خودم هستم"
                  onChange={(event) => setIsSelf(event.currentTarget.checked)}
                />
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Input
                    register={register}
                    errors={errors}
                    name="name"
                    defaultValue={isSelf ? user?.name : address?.name}
                    label="نام "
                    required
                    disabled={isSelf}
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <Input
                    register={register}
                    errors={errors}
                    name="family"
                    defaultValue={isSelf ? user?.surname : address?.name}
                    label="نام خانوادگی "
                    required
                    disabled={isSelf}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Input
                    register={register}
                    errors={errors}
                    name="mobile"
                    defaultValue={isSelf ? user?.mobile : address?.mobile}
                    label="تلفن همراه"
                    required
                    disabled={isSelf}
                  />
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Input
                    register={register}
                    errors={errors}
                    name="company"
                    defaultValue={address?.company}
                    label=" نام شرکت (اختیاری)"
                    required
                    disabled={isSelf}
                  />
                </div>
              </div>
            </div>
          </form>
          <div className="text-left modal-button p-5 border-t border-light-gray-300 absolute bottom-0 left-0 right-0 bg-white">
            <button
              form="editAddress"
              className="px-8 py-2 bg-button-color-primary text-white rounded-md text-sm"
              type="submit"
            >
              ثبت
            </button>
          </div>
        </>
      </Modal>
    </div>
  );
}
